import { useOutletContext } from 'react-router-dom'

import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'
import {
  AtsCandidateApplicationsDocument,
  CandidateDetailFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { CandidateApplicationsList } from 'modules/ats/components/CandidateApplicationsList'

import { CandidateAIHighlights } from './CandidateDetailPage/components/CandidateAIHighlights'

const CandidateApplications = () => {
  const { candidate } = useOutletContext<{ candidate: CandidateDetailFragment }>()
  const totalApplicationsCount = (candidate.atsJobPostingIds || []).length
  const candidateAtsApplicationsIds = candidate.atsJobPostingIds?.map((id: number) => id) || []

  const { data, loading } = useQuery(AtsCandidateApplicationsDocument, {
    variables: { applicationIds: candidateAtsApplicationsIds, candidateId: Number(candidate.id) },
  })

  const candidateAiData = data?.ats.applicationSummariesConnection.nodes[0]

  const relatedApplications = data?.ats.relatedCandidateApplicationsConnection.nodes || []

  return (
    <Box gap="s24">
      {candidateAiData && !loading && <CandidateAIHighlights data={candidateAiData} />}

      {relatedApplications.length > 0 ? (
        loading ? (
          <Box alignItems="center" paddingY="s24">
            <Spinner />
          </Box>
        ) : (
          <CandidateApplicationsList
            totalApplicationsCount={totalApplicationsCount}
            relatedApplications={relatedApplications}
          />
        )
      ) : (
        <Box alignItems="center" textAlign="center" gap="s24" paddingTop="s48">
          <Text.Normal>
            {i18n.t('ats.candidate_details.applications.add_to_first_job_opening')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default CandidateApplications
